export default __webpack_public_path__ + "static/media/CA-6 App overview page.d1b5651f.png";